<p-progressSpinner *ngIf="!balanceMetric.initialized" [style]="{width: '50px', height: '50px'}" fxFlex="1 1 auto" class="spinner"
    animationDuration="2s"></p-progressSpinner>

<div *ngIf="balanceMetric.initialized" fxFlex="auto" fxLayout="row" class="trend-metric" [ngStyle]="{'background-color': lightMetricColor(balanceMetric)}">
    <div fxFlex="auto" fxLayout="row">
        <span fxFlex="1 1 20%" fxFlexAlign="end" ></span>
        <!-- <span fxFlex="1 1 25%" class="balance-metric-current liquitics-h3">+{{balanceMetric.currentThroughput | currencyrounding:0:balanceMetric.currency:false}}</span> -->
        <span fxFlex="1 1 25%" class="balance-metric-currency liquitics-h3">{{balanceMetric.currency}}</span>
        <span fxFlex="1 1 35%" class="balance-metric-balance liquitics-h1">{{balanceMetric.balance | currencyrounding:0:balanceMetric.currency:'symbol-narrow'}}</span>
        <span fxFlex="1 1 10%" class="liquitics-h3"></span>
        <div fxFlex="1 1 5%" class="trend-metric-delta"></div>
        <span fxFlex="1 1 5%" fxFlexAlign="end"></span>
    </div>
</div>